import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left text-no-wrap" }
const _hoisted_2 = { class: "text-right text-no-wrap" }
const _hoisted_3 = { class: "text-right text-no-wrap" }
const _hoisted_4 = { class: "text-right text-no-wrap" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createBlock(_component_v_table, { density: "compact" }, {
    default: _withCtx(() => [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_1, _toDisplayString(_ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Name",1)), 1),
          _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t("message.car")), 1),
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t("message.pedestrian")), 1),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$tc("message.score",1)), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.area.locations, (locationForArea) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: locationForArea.location.ID
          }, [
            _createElementVNode("td", _hoisted_5, _toDisplayString(locationForArea.location.name), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(locationForArea.minutesCar), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(locationForArea.minutesPedestrian), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$filters.fixed(locationForArea.score, 4, _ctx.$i18n.locale)), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}